export default __webpack_public_path__ + "f9d06866a2a84e69fd32fc5457682eb1.svg";